<template>
  <v-container fill-height justify-center align-center>
    <v-card width="400" class="pa-6">
      <v-card-title class="text-center">
        <v-icon left>mdi-lock</v-icon>
        Changer le mot de passe
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="submit">
          <v-text-field
            v-model="currentPassword"
            :type="showCurrent ? 'text' : 'password'"
            label="Mot de passe actuel"
            :append-inner-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="showCurrent = !showCurrent"
            variant="outlined"
            class="mb-4"
            required
          ></v-text-field>

          <v-text-field
            v-model="newPassword"
            :type="showNew ? 'text' : 'password'"
            label="Nouveau mot de passe"
            :append-inner-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="showNew = !showNew"
            variant="outlined"
            class="mb-4"
            required
          ></v-text-field>

          <v-text-field
            v-model="confirmPassword"
            :type="showConfirm ? 'text' : 'password'"
            label="Confirmer le nouveau mot de passe"
            :append-inner-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="showConfirm = !showConfirm"
            variant="outlined"
            class="mb-6"
            required
          ></v-text-field>

          <v-btn type="submit" color="primary" block> Changer le mot de passe </v-btn>

          <v-btn to="/dashboard" variant="text" block class="mt-2"> Annuler </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/store/app";
import { useSessionStore } from "@/store";
import { changePassword } from "@/utils/user-api";

const router = useRouter();
const appStore = useAppStore();
const session = useSessionStore();

const currentPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");
const showCurrent = ref(false);
const showNew = ref(false);
const showConfirm = ref(false);

const submit = async () => {
  if (!currentPassword.value || !newPassword.value || !confirmPassword.value) {
    appStore.sendErrorNotice("All fields are required");
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    appStore.sendErrorNotice("Passwords do not match");
    return;
  }

  if (newPassword.value.length < 8) {
    appStore.sendErrorNotice("Password must be at least 8 characters");
    return;
  }

  try {
    await changePassword(session.loggedUser.id, currentPassword.value, newPassword.value);
  } catch (error) {
    appStore.sendErrorNotice("Failed to change password: " + error.message);
    return;
  }

  appStore.sendSuccessNotice("Password changed successfully");
  router.push("/dashboard");
};
</script>
